import { FintecConfig } from '../types/tink.interface'

export const defaultConfig: Partial<FintecConfig> = {
  'validate-login-credentials': false,
  'autocomplete-suggestions': 1,
  'next-button-text': 'Weiter (Digitaler Kontoauszug)',
  'back-button-text': 'Zurück',
  'focus-onload': false,
  'validate-privacy-policy': false,
  'open-privacy-policy-in-tab': true,
  'logo-height': 30,
  'logo-alignment': 'center',
}

export const allowedIbanCountries = ['DE', 'AT', 'CH']
